import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PaginatedPerformancesOverviewResponse } from './performance-overview.interface';
import { PerformanceOverviewService } from './performance-overview.service';
import { isOverviewPaginationMeta } from '@/core/models/overview-pagination.interface';

const service = new PerformanceOverviewService();

export interface PerformanceOverviewState {}

const PerformanceOverviewStore: Module<PerformanceOverviewState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getPerformanceCustomers(context, payload: { query?: LocationQuery }) {
         const response = await service.getPerformancesCustomers(payload.query);
         return response.data;
      },
      async getPerformanceOverview(context, payload: { query?: LocationQuery }): Promise<PaginatedPerformancesOverviewResponse> {
         const response = await service.getPerformancesOverview(payload.query);

         if (response?.customers && isOverviewPaginationMeta(response.meta)) {
            return response;
         }

         const customers = response?.customers ? response.customers : response ? [response] : [];

         return {
            customers,
            meta: {
               current_page: 1,
               per_page: customers.length || 25,
               total: customers.reduce((total, customer) => total + (customer.performances_overview?.length ?? 0), 0),
               last_page: 1,
               from: customers.length ? 1 : null,
               to: customers.length
                  ? customers.reduce((total, customer) => total + (customer.performances_overview?.length ?? 0), 0)
                  : null,
            },
         };
      },
   },
};

export default PerformanceOverviewStore;
